import React from 'react';
import { prop } from 'ramda';
import * as urlUtil from 'js/utils/url.util';
import { useAppSelector } from 'js/store/hooks';
import { Icon } from 'js/components/common/Icon';
import { BackboneReplacer } from 'js/backbone/components/BackboneReplacer';
import { AccessibilityElement } from 'js/components/common/AccessibilityElement';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as hooks from '../../hooks';

import * as style from './Inbox.scss';

export const Inbox: React.FC = () => {
    const translate = useComponentTranslations();
    const inboxWidget = useAppSelector(prop('inboxWidget'));
    const onInboxButtonClick = hooks.useOnInboxButtonClick();
    const hideInboxByUrl = urlUtil.getLocationParam('hideInbox') === '1';
    const showInbox = inboxWidget.showIcon && inboxWidget.enabled && !hideInboxByUrl;

    return showInbox
        ? (
            <AccessibilityElement
                tagName="span"
                className={style.inbox}
                onClick={onInboxButtonClick}
                aria-label={translate('header.inboxBtn')}
            >
                <Icon type="headerInbox" className={`${style.icon} cms-icon-inbox`} />
                <BackboneReplacer
                    viewName="unreadmessagescount"
                    dynamicName="UNREAD_MESSAGES_COUNT"
                />
            </AccessibilityElement>
        )
        : null;
};
